import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const css = `
.dock-brand {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 40px;
    padding: 0;
    border-radius: 12px;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: background 0.18s, transform 0.1s;
    text-decoration: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    flex-shrink: 0;
    color: inherit;
}

.dock-brand:hover {
    background: rgba(0, 0, 0, 0.06);
}

.dock-brand:active {
    transform: scale(0.94);
}

.dock-brand--non-interactive {
    cursor: default;
}

.dock-brand--non-interactive:hover {
    background: transparent;
}

.dock-brand--non-interactive:active {
    transform: none;
}

.dock-brand__logo {
    height: 26px;
    width: auto;
    display: block;
}
`;
// Лого 3DP — встроенное, не зависит от ассетов
const BrandMark = () => (_jsxs("svg", { className: "dock-brand__logo", viewBox: "0 0 1200 630", xmlns: "http://www.w3.org/2000/svg", "aria-label": "3DP", children: [_jsx("path", { fill: "#242935", d: "M418.91,273.37c69.75,44.78,23.34,124.19-37.5,124.19-30.4-.28-70.98-24.56-70.98-67.97,13.31,0,23.13-.16,44.68-.16,0,24.84,15.75,33.42,29.76,33.91,46.76,0,46.12-68.52-16.18-68.52,0-30.86,0-7.42,0-33.9,10.31-.35,38.23-1.14,37.52-30.37s-47.11-29.59-47.11,4.3c-14.1,0-27.44.04-42.73.04,0-64.11,80.12-79.25,115.93-43.21,18.35,18.79,24.21,56.1-13.38,81.69Z" }), _jsx("rect", { fill: "#2fb886", x: "846.7", y: "354.66", width: "42.86", height: "42.86" }), _jsx("path", { fill: "#272c38", d: "M740.58,226.55c-17.97,2.31-33.88,17.88-39.27,24.81,0-9.24.09-15.91.09-24.9-8.9,0-23.36-.09-38.67-.09v230.99l38.76.09v-77.08c137.05,84.52,160.84-164,39.1-153.82ZM747.94,363.6c-51.16,4.62-50.9-91.8-14.89-101.81,59.03-16.34,62.45,97.53,14.89,101.81Z" }), _jsx("path", { fill: "#272c38", d: "M590.61,175.73v59.89c-137.48-57.83-156.56,176.49-30.71,161.78,15.57-1.88,24.38-10.09,30.71-17.28v17.45c13.17,0,31.91-.09,39.52-.09v-222.43l-39.52.68ZM559.98,363.86c-48.76,4.71-61.77-88.55-15.31-102.06,57.23-16.68,59.46,97.79,15.31,102.06Z" })] }));
export function DockBrand({ href, newTab = true, title = 'Made with 3DP', }) {
    const className = [
        'dock-brand',
        !href && 'dock-brand--non-interactive',
    ].filter(Boolean).join(' ');
    if (href) {
        return (_jsxs(_Fragment, { children: [_jsx("style", { children: css }), _jsx("a", { className: className, href: href, target: newTab ? '_blank' : undefined, rel: newTab ? 'noopener noreferrer' : undefined, title: title, "aria-label": title, children: _jsx(BrandMark, {}) })] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: css }), _jsx("div", { className: className, title: title, "aria-label": title, children: _jsx(BrandMark, {}) })] }));
}
